export default "__VITE_ASSET__ee246c90__"